import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getEnvironmentConfig } from '../utils/environment';

const { apiUrl } = getEnvironmentConfig();

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,
    prepareHeaders: (headers, { endpoint }) => {
      if (endpoint === 'getGeolocation' || endpoint === 'postFileToAWS') {
        return;
      }
      if (endpoint === 'getCountryRegions') {
        headers.set('x-rapidapi-host', 'wft-geo-db.p.rapidapi.com');
        headers.set('x-rapidapi-key', process.env.REACT_APP_RAPID_API_KEY || '');
        return;
      }
      headers.set('authorization', localStorage.getItem('Authorization') ?? '');
      if (localStorage.getItem('company-id')) {
        headers.set('company-id', localStorage.getItem('company-id'));
        headers.set('x-client-platform', 'WEB');
      }
    },
  }),
  keepUnusedDataFor: 10,
  tagTypes: [
    'Post Audience',
    'Specific Users',
    'User',
    'Company',
    'Template',
    'Projects',
    'Preference',
    'Current Plan',
    'Billing History',
    'Payment Plans',
    'Payment Methods',
    'Company Roles',
    'Profile Push Notifications',
    'Profile Email Notifications',
    'Company Push Notifications',
    'Company Email Notifications',
    'Invites',
    'Profiles',
    'Role Permissions',
    'Selection Category',
    'Selections Summary',
    'Project Cost Codes',
    'File Cabinet Folder',
    'File Cabinet',
    'Folder Permissions',
    'Default Cost Codes',
    'Default Cost Categories',
    'Checklists Templates',
    'Checklists Template Items',
    'Schedule Checklists',
    'Invite Existence',
    'Selections Templates',
    'Selections Template',
    'Unviewed Counts',
    'Selection Variant Types',
    'Selection Variant Library',
    'SelectionItem',
    'Project Cost Code Categories',
    'Schedule Templates Checklist',
    'Project File Cabinet Deleted Files',
  ],
  endpoints: () => ({}),
});
